import { render, staticRenderFns } from "./FormEmergency.vue?vue&type=template&id=1c15c00b"
import script from "./FormEmergency.vue?vue&type=script&lang=ts"
export * from "./FormEmergency.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports